var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6615 13.9996H9.32814M2.32812 14.3329L6.02764 12.91C6.26427 12.819 6.38258 12.7735 6.49327 12.7141C6.59159 12.6613 6.68532 12.6004 6.77349 12.532C6.87274 12.4549 6.96237 12.3653 7.14164 12.186L14.6615 4.66622C15.3979 3.92984 15.3979 2.73593 14.6615 1.99955C13.9251 1.26317 12.7312 1.26317 11.9948 1.99955L4.47498 9.51936C4.29571 9.69863 4.20607 9.78827 4.12905 9.88752C4.06064 9.97569 3.99973 10.0694 3.94695 10.1677C3.88753 10.2784 3.84202 10.3967 3.75101 10.6334L2.32812 14.3329ZM2.32812 14.3329L3.70021 10.7655C3.79839 10.5102 3.84748 10.3826 3.93169 10.3241C4.00527 10.273 4.09633 10.2537 4.18432 10.2705C4.28501 10.2898 4.38171 10.3865 4.57511 10.5799L6.08117 12.0859C6.27457 12.2793 6.37127 12.376 6.3905 12.4767C6.40731 12.5647 6.38798 12.6558 6.33689 12.7293C6.27842 12.8135 6.15078 12.8626 5.89551 12.9608L2.32812 14.3329Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestPen);
export default __webpack_public_path__ + "static/media/suggest-pen.4ab73b1a7fe76319ac622d824726a020.svg";
export { ForwardRef as ReactComponent };